export default __webpack_public_path__ + "static/media/forbidden.a2c23a4c.png";